<template>
  <div>
    <v-col v-if="!canWrite || hasMultipleActiveWatchers">
      <v-card-text class="pa-0">
        <v-icon color="red">mdi-alert-box-outline</v-icon>
        {{ hasMultipleActiveWatchers ? $t('vmail.notify.hasMultipleWatchers') : $t('perms.nochange') }}
      </v-card-text>
    </v-col>
    <v-row v-if="displayGreetingCards">
      <v-col xs="12" sm="12" md="6" lg="6" xl="4">
        <greeting-card
          :title="$t('vmail.cfg.greeting.name')"
          help-key="vm.greeting.name"
          icon="mdi-account-circle"
          api-name="greeting"
          :default-tts-text="defaultNameGreetingTtsText">
        </greeting-card>
      </v-col>
      <v-col xs="12" sm="12" md="6" lg="6" xl="4">
        <greeting-card
          :title="$t('vmail.cfg.greeting.busy')"
          help-key="vm.greeting.busy"
          icon="mdi-calendar-remove"
          api-name="busy"
          :default-tts-text="defaultBusyGreetingTtsText">
        </greeting-card>
      </v-col>
      <v-col xs="12" sm="12" md="6" lg="6" xl="4">
        <greeting-card
          :title="$t('vmail.cfg.greeting.unavail')"
          help-key="vm.greeting.unavail"
          icon="mdi-airplane"
          api-name="unavailable"
          :default-tts-text="defaultUnavailableGreetingTtsText">
        </greeting-card>
      </v-col>
      <v-col xs="12" sm="12" md="6" lg="6" xl="4">
        <greeting-card
          :title="$t('vmail.cfg.greeting.temp')"
          help-key="vm.greeting.temp"
          icon="mdi-clock"
          api-name="temp"
          :default-tts-text="defaultTemporaryGreetingTtsText">
        </greeting-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GreetingCard from './card'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'vmail-greetings',
  components: { GreetingCard },
  mounted () {
    this.getTTSVoiceTypes()
  },
  computed: {
    ...mapGetters({
      canWrite: 'permissions/vmboxesWrite',
      activeWatchers: 'voicemails/activeWatchers',
      currentUser: 'currentUser/currentUser'
    }),
    displayGreetingCards: function () {
      return this.activeWatchers && this.activeWatchers.length > 0
    },
    hasMultipleActiveWatchers: function () {
      return this.activeWatchers.length > 1
    },
    defaultNameGreetingTtsText: function () {
      return this.$t('vmail.cfg.greeting.default.name', {
        name: `${this.currentUser?.firstName} ${this.currentUser?.lastName}`
      })
    },
    defaultBusyGreetingTtsText: function () {
      return this.$t('vmail.cfg.greeting.default.busy', {
        name: `${this.currentUser?.firstName} ${this.currentUser?.lastName}`
      })
    },
    defaultUnavailableGreetingTtsText: function () {
      return this.$t('vmail.cfg.greeting.default.unavailable', {
        name: `${this.currentUser?.firstName} ${this.currentUser?.lastName}`
      })
    },
    defaultTemporaryGreetingTtsText: function () {
      return this.$t('vmail.cfg.greeting.default.temp', {
        name: `${this.currentUser?.firstName} ${this.currentUser?.lastName}`
      })
    }
  },
  methods: {
    ...mapActions({
      getTTSVoiceTypes: 'announcements/getTTSVoiceTypes'
    })
  }
}
</script>

<style scoped>
</style>
